/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GlobalMonthlyGuildMember,
    GlobalMonthlyGuildMemberFromJSON,
    GlobalMonthlyGuildMemberFromJSONTyped,
    GlobalMonthlyGuildMemberToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetGlobalMonthlyGuildLeaderboardResponse
 */
export interface GetGlobalMonthlyGuildLeaderboardResponse {
    /**
     * 
     * @type {Array<GlobalMonthlyGuildMember>}
     * @memberof GetGlobalMonthlyGuildLeaderboardResponse
     */
    members: Array<GlobalMonthlyGuildMember>;
}

export function GetGlobalMonthlyGuildLeaderboardResponseFromJSON(json: any): GetGlobalMonthlyGuildLeaderboardResponse {
    return GetGlobalMonthlyGuildLeaderboardResponseFromJSONTyped(json, false);
}

export function GetGlobalMonthlyGuildLeaderboardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGlobalMonthlyGuildLeaderboardResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'members': ((json['members'] as Array<any>).map(GlobalMonthlyGuildMemberFromJSON)),
    };
}

export function GetGlobalMonthlyGuildLeaderboardResponseToJSON(value?: GetGlobalMonthlyGuildLeaderboardResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'members': ((value.members as Array<any>).map(GlobalMonthlyGuildMemberToJSON)),
    };
}


